import _ from 'lodash/fp';
import { createAction } from 'redux-act';

const mapValuesWithKey = _.mapValues.convert({ cap: false });

// Object -> Array
// inserts keys as 'id' field
export const toArray = _.flow(
  mapValuesWithKey((item, id) => ({ ...item, id })),
  _.values
);

export const createActions = _.mapValues(createAction);



// WEBPACK FOOTER //
// ./src/reducers/util/index.js